import { Breadcrumb } from "antd";
import { useMemo } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import cloneDeep from 'lodash/cloneDeep'

const findMenuItem = (menuList, path) => {
  if (!menuList || menuList.length <= 0) return null;
  let nodes = [];
  menuList.forEach((menu) => {
    if (menu.path === path) {
      nodes.push(menu);
    } else if (menu.children) {
      let childNodes = findMenuItem(menu.children, path);
      if (childNodes.length > 0) {
        nodes = [menu, ...childNodes];
      }
    }
  });
  return nodes;
};

const MainBreadcrumb = ({ menuList }) => {
  const location = useLocation();
  const nodes = useMemo(() => {
    if (!menuList || menuList.length <= 0) return [];
    const copyMenuList = cloneDeep(menuList);
    copyMenuList.forEach(item=>{
      if (item.path === '/product') {
        if (item.children && item.children.length>0){
          // 商家商品档案
          const index = item.children.findIndex((cItem)=>(cItem.path === '/product/merchant-product/list'))
          if (index > -1){
            item.children[index].children = [
              {path: '/product/create', name:'新建商品'},
              {path: '/product/edit', name:'编辑商品'},
              {path: '/product/detail', name:'商品详情'}
            ]
          }
          // 门店商品档案
          const indexx = item.children.findIndex((cItem)=>(cItem.path === '/product/store-product/page'))
          if (indexx > -1){
            item.children[indexx].children = [
              {path: '/product/store-product/create', name:'新建商品'},
              {path: '/product/store-product/edit', name:'编辑商品'},
              {path: '/product/store-product/detail', name:'商品详情'}
            ]
          }
        }
      }
      if (item.path === '/activity'){
        if (item.children && item.children.length>0){
          const index = item.children.findIndex((cItem)=>(cItem.path === '/activity/group/search'))
          if (index > -1){
            item.children[index].children = [
              {path: '/activity/group/edit', name:'创建团购活动'},
              {path: '/activity/group/detail', name:'团购活动详情'}
            ]
          }
        }
      }
      if (item.path === '/inventory'){
        if (item.children && item.children.length>0){
          const index = item.children.findIndex((cItem)=>(cItem.path === '/inventory/allocation'))
          if (index > -1){
            item.children[index].children = [{path: '/inventory/product-transfers/edit', name:'新建商品调拨'}]
          }
        }

      }
    })
    return findMenuItem(copyMenuList, location.pathname) || [];
  }, [location, menuList]);
  return (
    <Breadcrumb>
      <Breadcrumb.Item>
        <Link to="/">首页</Link>
      </Breadcrumb.Item>
      {nodes.map((n) => (
        <Breadcrumb.Item key={n.path}>{n.name}</Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default connect((state) => ({ menuList: state.auth.menuList }))(
  MainBreadcrumb
);
